
import { RefreshCw } from "lucide-react";

const ConversationLoadingState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative">
        <div className="h-16 w-16 rounded-full border-4 border-gray-200"></div>
        <RefreshCw className="h-8 w-8 animate-spin absolute top-4 left-4 text-primary" />
      </div>
      <p className="text-muted-foreground mt-4">Loading conversation details...</p>
    </div>
  );
};

export default ConversationLoadingState;
